<div class="row">
  <div class="col-12 col-md-6 mb-3">
    <div class="row align-items-center">
      <div class="col-12 col-sm-6 col-md-4 mb-1">
        <label>{{ title() | translate }}</label>
      </div>
      <div class="col-12 col-sm-6 col-md-8">
        <div class="form-check form-check-inline form-check-lg">
          <input
            class="form-check-input me-2"
            type="radio"
            [id]="field() + '.question' + 'Yes'"
            [formControlName]="property()"
            [attr.data-cy]="field() + '-radio-yes'"
            [value]="true"
          />
          <label class="form-check-label" [for]="field() + '.question' + 'Yes'">
            {{ 'common.yes' | translate }}
          </label>
        </div>
        <div class="form-check form-check-inline form-check-lg">
          <input
            class="form-check-input me-2"
            type="radio"
            [id]="field() + '.question' + 'No'"
            [formControlName]="property()"
            [attr.data-cy]="field() + '-radio-no'"
            [value]="false"
          />
          <label class="form-check-label" [for]="field() + '.question' + 'No'">
            {{ 'common.no' | translate }}
          </label>
        </div>
      </div>
    </div>
    <div class="row justify-content-end">
      <div class="col-12 col-sm-6 col-md-8">
        <app-validation-error
          [for]="property()"
          [translations]="validationTranslation() || 'validation.generic'"
          [attr.data-cy]="field() + '-validation-error'"
        ></app-validation-error>
      </div>
    </div>
  </div>
  @if (descriptionProperty() && form.get(property()).value) {
    <div class="col-12 col-md-6 mb-3">
      <div class="row align-items-center">
        <div class="col-12 col-sm-6 col-md-4 mb-1">
          <label [for]="field() + '.description'">
            {{ descriptionTitle() | translate }}
          </label>
        </div>
        <div class="col-12 col-sm-6 col-md-8">
          <input
            class="form-control"
            type="text"
            [id]="field() + '.description'"
            [formControlName]="descriptionProperty()"
            [attr.data-cy]="field() + '-description-input'"
            [placeholder]="descriptionPlaceholder() | translate"
          />
        </div>
      </div>
      <div class="row justify-content-end">
        <div class="col-12 col-sm-6 col-md-8">
          <app-validation-error
            [for]="descriptionProperty()"
            translations="validation.generic"
            [attr.data-cy]="field() + '-description-validation-error'"
          />
        </div>
      </div>
    </div>
  }
</div>
